export default __webpack_public_path__ + "static/media/AND.1324996d.svg";